<template>
  <div class="view">
    <Title title="参加者(クローズド)"/>
    <EntryClosedMain/>
  </div>
</template>

<script>
import Title from '@/components/Title.vue'
import EntryClosedMain from '@/components/EntryClosedMain'

export default {
  components: {
    Title,
    EntryClosedMain
  },

  created: function () {
    this.$store.dispatch('eventClosed/get', this.$route.params.id)
    this.$store.dispatch('entryClosed/retrieve', this.$route.params.id)
  }
}
</script>

